import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import { reportWebVitals, addResourceHints } from './utils/performance';

// Add resource hints for better performance
addResourceHints();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Report web vitals for performance monitoring
reportWebVitals(); 